import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Crown, Trash, UserPlus } from "@phosphor-icons/react";
import { adminAdminsApi, adminAddAdminApi, adminRemoveAdminApi, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const err = (e) => toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Something went wrong");

export function AdminsPanel() {
  const { user, refresh } = useAuth();
  const [list, setList] = useState([]);
  const [email, setEmail] = useState("");
  useEffect(() => { adminAdminsApi().then(setList).catch(err); }, []);

  const add = async (e) => {
    e.preventDefault();
    try { setList(await adminAddAdminApi(email.trim())); setEmail(""); toast.success("Admin added"); } catch (x) { err(x); }
  };
  const remove = async (a) => {
    if (!window.confirm(`Remove admin access for ${a.email}?`)) return;
    try {
      setList(await adminRemoveAdminApi(a.email));
      toast.success("Admin removed");
      if (a.email === user.email) refresh();
    } catch (x) { err(x); }
  };

  return (
    <div className="stp-card max-w-2xl rounded-3xl p-6 sm:p-8" data-testid="admins-panel">
      <h2 className="font-display text-2xl font-semibold text-ink">Admins</h2>
      <p className="mt-1 text-sm text-mist">Admins can run the sale, see revenue, manage users and reports. They also get full Team access.</p>
      <form onSubmit={add} className="mt-5 flex gap-2">
        <input data-testid="admin-add-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="name@company.com" className="h-11 min-w-0 flex-1 rounded-full border border-black/10 bg-white px-4 text-sm text-ink outline-none focus:border-brand focus:ring-4 focus:ring-brand/15" />
        <button data-testid="admin-add-button" aria-label="Add admin" className="flex h-11 shrink-0 items-center gap-1.5 rounded-full bg-ink px-4 text-sm font-semibold text-white hover:bg-black sm:px-5"><UserPlus size={15} /> <span className="hidden sm:inline">Add admin</span></button>
      </form>
      <ul className="mt-5 divide-y divide-black/5">
        {list.map((a) => (
          <li key={a.email} className="flex items-center justify-between py-3" data-testid="admin-row">
            <span>
              <span className="flex items-center gap-2 text-sm font-medium text-ink">{a.email} {a.owner && <span className="flex items-center gap-1 rounded-full bg-[#FFF4E5] px-2 py-0.5 text-[10px] font-semibold text-[#C93400]"><Crown size={10} weight="fill" /> Owner</span>}</span>
              <span className="text-xs text-mist">{a.has_account ? "Has an account" : "Becomes admin when they sign up"}</span>
            </span>
            {!a.owner && a.email !== user.email && <button data-testid="admin-remove-button" onClick={() => remove(a)} className="flex h-9 items-center gap-1 rounded-full px-3 text-xs text-mist hover:bg-[#FFECEE] hover:text-[#D70015]"><Trash size={14} /> Remove</button>}
          </li>
        ))}
      </ul>
    </div>
  );
}
